/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import BlockedUser from 'entities/BlockedUser';

export default class BlockedUsers extends Collection<BlockedUser> {
  initialize() {
    this.model = BlockedUser;
  }

  static load() {
    return apiRequest('/related_users/blocked', 'GET').then(blockedUsers =>
      BlockedUsers.fromJSON(blockedUsers)
    );
  }
}
